var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-center"},[_c('span',{staticClass:"h-3 w-3 mr-1 block rounded-full",class:_vm.classObject.dot}),_c('p',{class:_vm.classObject.label},[_c('b',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }